import { Controller } from "@stimulus/core";

export default class extends Controller {
  static targets = [];
  static values = {};

  initialize() {}
  connect() {}
  disconnect() {}
}